module.exports = __webpack_public_path__ + "img/roullet_arrow.8b913670.png";